import { type PropsWithChildren, useState } from "react";
import { Link, NavLink } from "react-router-dom";

import { utiliserSession } from "../auth/SessionContext";

export function Layout({ children }: PropsWithChildren) {
  const { session, deconnecter } = utiliserSession();
  const [menuOuvert, definirMenuOuvert] = useState(false);
  const estAdmin = session?.utilisateur.role_global === "ADMIN_TICKBOSS";

  return (
    <div className="app-shell">
      <a className="skip-link" href="#contenu">
        Aller au contenu
      </a>
      <header className="entete">
        <Link to="/" className="marque" aria-label="Tickboss Production, accueil">
          <span className="marque__symbole" aria-hidden="true">
            T
          </span>
          <span>
            <strong>Tickboss</strong>
            <small>Production</small>
          </span>
        </Link>
        <button
          className="menu-mobile"
          type="button"
          aria-expanded={menuOuvert}
          aria-controls="navigation-principale"
          onClick={() => definirMenuOuvert((valeur) => !valeur)}
        >
          Menu
        </button>
        <nav
          id="navigation-principale"
          className={menuOuvert ? "navigation navigation--ouverte" : "navigation"}
          aria-label="Navigation principale"
        >
          <NavLink to="/catalogue" onClick={() => definirMenuOuvert(false)}>
            Catalogue
          </NavLink>
          {session ? (
            <>
              <NavLink to="/espace" onClick={() => definirMenuOuvert(false)}>
                Mon espace
              </NavLink>
              {estAdmin && (
                <NavLink to="/imports" onClick={() => definirMenuOuvert(false)}>
                  À raccorder
                </NavLink>
              )}
              <button
                className="bouton bouton--discret"
                type="button"
                onClick={() => {
                  deconnecter();
                  definirMenuOuvert(false);
                }}
              >
                Se déconnecter
              </button>
            </>
          ) : (
            <>
              <NavLink to="/connexion">Se connecter</NavLink>
              <Link className="bouton bouton--primaire" to="/inscription">
                Créer mon espace
              </Link>
            </>
          )}
        </nav>
      </header>
      <main id="contenu">{children}</main>
      <footer className="pied">
        <div>
          <strong>Tickboss Production</strong>
          <p>Le spectacle vivant, de la découverte à la programmation.</p>
        </div>
        <div className="pied__liens">
          <Link to="/catalogue">Catalogue</Link>
          <a href="/docs">API</a>
          <span>Service gratuit · Sans commission</span>
        </div>
      </footer>
    </div>
  );
}
